import { ByteArray } from "../ByteArray"
import { ICommand } from "./ICommand"

export class CMDScStartBet implements ICommand
{

	public HostID : number = 0;
	public FGameID : bigint = 0n; 
	public GameID : number = 0;
	public GameCount : number = 0;
	public RemainTime : number = 0;

	public constructor()
	{
	}

	public fromBytes(ba : ByteArray) : void
	{
		this.HostID = ba.readUint16();
		this.FGameID = ba.readUint64();
		this.GameID = Number(this.FGameID);
		this.GameCount = ba.readUint32();
		this.RemainTime = ba.readUint32();
	}

	public toBytes() : ByteArray
	{
		let ba: ByteArray = new ByteArray();

		ba.writeUint16(this.HostID);
		ba.writeUint64(this.FGameID);
		ba.writeUint32(this.GameCount);
		ba.writeUint32(this.RemainTime);

		return ba;
	}

	public clone() : ICommand
	{
		let cmd : ICommand = new CMDScStartBet();
		cmd.fromBytes(this.toBytes());

		return cmd;
	}

	public toString() : string
	{
		let str:string = '';
		str += 'HostID(W)='+this.HostID+' ';
		str += 'GameID(F)='+this.GameID+' ';
		str += 'GameCount(D)='+this.GameCount+' ';
		str += 'RemainTime(D)='+this.RemainTime+' ';
		return str;
	}

	public getCmdID() : number
	{
		return 30003;
	}

	public getCmdName() : string
	{
		return 'ScStartBet';
	}

}
